import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/home/runner/work/hypertask-static-homepage/hypertask-static-homepage/node_modules/next/dist/client/app-dir/link.js");
